var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-image"},[_c('uploader',{attrs:{"src":_vm.obj.url},on:{"uploaded":_vm.uploaded}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }